import type { CampaignEmailTemplateType } from "@vicnet/shared";

export const campaignTemplateFlow: Record<CampaignEmailTemplateType, { order: number; stage: string }> = {
  INITIAL_DECISION_MAKER: { order: 1, stage: "1 · Contacto inicial · variantes alternativas" },
  INITIAL_INFLUENCER: { order: 2, stage: "1 · Contacto inicial · variantes alternativas" },
  INITIAL_ROUTER: { order: 3, stage: "1 · Contacto inicial · variantes alternativas" },
  FOLLOW_UP_1: { order: 4, stage: "2 · Seguimiento si no hay respuesta" },
  FOLLOW_UP_2: { order: 5, stage: "2 · Seguimiento si no hay respuesta" },
  REFERRAL_CLARIFICATION: { order: 6, stage: "3 · Respuesta del contacto · rama de derivación" },
  QUESTION_RESPONSE: { order: 7, stage: "3 · Respuesta del contacto · rama de consulta" },
  MEETING_OPTIONS: { order: 8, stage: "4 · Coordinación de reunión" },
  MEETING_OPTIONS_FOLLOW_UP: { order: 9, stage: "4 · Seguimiento de horarios" },
  CALENDAR_INVITATION: { order: 10, stage: "5 · Calendar · invitación" },
  CALENDAR_UPDATE: { order: 11, stage: "6 · Calendar · actualización" },
  CALENDAR_CANCELLATION: { order: 12, stage: "7 · Calendar · cancelación si corresponde" },
};

export function templatesInFlowOrder<T extends { type: CampaignEmailTemplateType }>(items: T[]): T[] {
  return [...items].sort((a, b) => (campaignTemplateFlow[a.type]?.order ?? 99) - (campaignTemplateFlow[b.type]?.order ?? 99));
}

export function initialTemplateCompatible(actionKind: string | null | undefined, type: CampaignEmailTemplateType) {
  return actionKind === "INITIAL" ? ["INITIAL_DECISION_MAKER", "INITIAL_INFLUENCER", "INITIAL_ROUTER"].includes(type)
    : actionKind === "MEETING_OPTIONS" && type === "MEETING_OPTIONS";
}
